import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { get } from 'lodash'
import AdminCommonListTable from '../layout/AdminCommonListTable'
import AdminVettingContactForm from './form/AdminVettingContactForm'
import { showSuccess, showError } from 'actions/Error'
import { Avatar } from '@material-ui/core'
import { adminContactListVetting } from 'admin/components/contacts/actions/admin_contact'
import { adminBeneficiaryVettingList } from './actions/admin_beneficiary_vetting'
import { Modal } from 'components/layout/Modal'

export default function AdminVettingContacts({ beneficiary_vetting_id, inTabs }) {
  const dispatch = useDispatch()
  const is_loading = useSelector(() => !adminContactListVetting.isReady() && adminContactListVetting.isLoading())
  const vetting = useSelector(() => adminBeneficiaryVettingList.getObject(beneficiary_vetting_id))
  const vetting_status = get(vetting, 'status')
  const actionsDisabled = vetting_status !== 'vetting_in_progress'
  const [editingContact, setEditingContact] = useState(null)
  const [contactId, setContactId] = useState(null)
  const [addEditLabel, setAddEditLabel] = useState(null)

  const listFilter = { beneficiary_vetting: beneficiary_vetting_id }
  const newContactInitialValues = { beneficiary_vetting: beneficiary_vetting_id }

  useEffect(() => {
    if (!beneficiary_vetting_id) return
    dispatch(adminContactListVetting.invalidateList())
    dispatch(adminContactListVetting.updateListFilter(listFilter))
    dispatch(adminContactListVetting.fetchListIfNeeded())
  }, [dispatch, beneficiary_vetting_id])

  const onAddContact = () => {
    setContactId(false)
    setAddEditLabel('Add Contact')
    setEditingContact(newContactInitialValues)
  }

  const onEditContact = (contact_id) => {
    setContactId(contact_id)
    setAddEditLabel(`Editing ${contact_id}`)
    setEditingContact(newContactInitialValues)
  }

  const onStopEditingContact = () => {
    dispatch(adminContactListVetting.invalidateList())
    dispatch(adminContactListVetting.fetchListIfNeeded())
    setEditingContact(null)
  }

  const onRemoveContact = (contact) => {
    if (!window.confirm('Are you sure you want to delete this contact?')) return
    const onDone = (res) => {
      if (res.errors) {
        showError('Failed', 'Contact is in use and could not be deleted')
      } else {
        showSuccess('Deleted', 'Contact deleted')
        dispatch(adminContactListVetting.invalidateList())
        dispatch(adminContactListVetting.fetchListIfNeeded())
      }
    }
    dispatch(adminContactListVetting.deleteObject(contact.id)).then(onDone)
  }

  const columns = [
    {
      field: 'profile_images',
      title: 'Image',
      width: 60,
      align: 'center',
      render: (item) => (
        <Avatar
          alt={`${get(item, 'first_name')} ${get(item, 'last_name')}`}
          src={get(item, ['profile_images', 'files', 0, 'original_download_url'])}
          style={{
            width: 60,
            height: 60,
            cursor: actionsDisabled ? 'default' : 'pointer',
            opacity: actionsDisabled ? 0.6 : 1
          }}
          onClick={() => !actionsDisabled && onEditContact(get(item, 'id'))}
        />
      )
    },
    {
      field: 'last_name',
      title: 'Name',
      render: (item) => (
        <a
          onClick={() => !actionsDisabled && onEditContact(get(item, 'id'))}
          style={{
            cursor: actionsDisabled ? 'default' : 'pointer',
            opacity: actionsDisabled ? 0.6 : 1,
            pointerEvents: actionsDisabled ? 'none' : 'auto'
          }}
        >
          {get(item, 'first_name')} {get(item, 'last_name')}
        </a>
      )
    },
    { field: 'role', title: 'Position' },
    { field: 'email', title: 'Email' },
    { field: 'mobile', title: 'Mobile' }
  ]

  return (
    <>
      <AdminCommonListTable
        add_label="Add Contact"
        title="Contact"
        onAddRow={actionsDisabled ? undefined : onAddContact}
        onEditRow={actionsDisabled ? undefined : onEditContact}
        canDelete={!actionsDisabled}
        is_loading={is_loading}
        columns={columns}
        item_list={adminContactListVetting}
        inTabs={inTabs}
      />

      {editingContact && (
        <Modal title={addEditLabel} onClose={() => setEditingContact(false)}>
          <AdminVettingContactForm
            beneficiary_vetting_id={beneficiary_vetting_id}
            contact_id={contactId}
            onDone={onStopEditingContact}
            setEditingContact={setEditingContact}
          />
        </Modal>
      )}
    </>
  )
}
